import ProductTilePlaceholder from "../../../../../ProductTilePlaceholder";
import styles from "./index.css";
import GoogleAdvert from "../GoogleAdvert";
import PropTypes from "prop-types";

const SavedTilesCollection = ({
  ProductTile,
  savedItems,
  showDiscountLabel,
  showExtendedPricing,
  isAuthenticated,
  isFullyLoaded,
  adPosition
}) => {
  const savedProductTilesCollection = savedItems.map((item, index) => (
    <li key={item.id}>
      {isFullyLoaded(item) ? (
        <ProductTile
          {...{
            ...item,
            index,
            showDiscountLabel,
            showExtendedPricing,
            isAuthenticated
          }}
        />
      ) : (
        <ProductTilePlaceholder itemState={item.itemState} />
      )}
    </li>
  ));

  savedProductTilesCollection.splice(
    adPosition,
    0,
    <li key="google-advert" className={styles.googleAdvertContainer}>
      <GoogleAdvert savedItems={savedItems} adPosition={adPosition} />
    </li>
  );

  return savedProductTilesCollection;
};

SavedTilesCollection.propTypes = {
  ProductTile: PropTypes.elementType.isRequired,
  savedItems: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      variants: PropTypes.array
    }).isRequired
  ),
  showDiscountLabel: PropTypes.bool.isRequired,
  showExtendedPricing: PropTypes.bool.isRequired,
  isAuthenticated: PropTypes.bool.isRequired,
  isFullyLoaded: PropTypes.func.isRequired,
  adPosition: PropTypes.number.isRequired
};

export default SavedTilesCollection;
